(function(app) {

    app.provider("businessApi",
        [
            function() {
                this.$get = [
                    "crmApiGateway", function(crmApiGateway) {
                        var service = {};

                        service.get = function(businessId) {
                            return crmApiGateway.get("/Businesses/" + businessId);
                        }

                        service.getBusinesses = function() {
                            return crmApiGateway.getArray("/Businesses");
                        }

                        service.update = function(businessId, business) {
                            return crmApiGateway.put("/Businesses/" + businessId, business);
                        }

                        service.updateIsActive = function(businessId, business) {
                            return crmApiGateway.put("/Businesses/" + businessId + "/IsActive", business);
                        }

                        service.create = function(business) {
                            return crmApiGateway.post("/Businesses", business);
                        }

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line